import { useAppConfigStore } from "@/pages/taskpane/shared/stores";
import { useEffect } from "react";

declare const Office: any;

function convertLanguageOAToLocal(language: string): string {
  if(language.toLowerCase().includes("zh")) return "zh-cn";
  else if(language.toLowerCase().includes("en")) return "en-gb";
  else if(language.toLowerCase().includes("cs")) return "cs";
  else if(language.toLowerCase().includes("da")) return "da";
  else if(language.toLowerCase().includes("nl")) return "nl";
  else if(language.toLowerCase().includes("fi")) return "fi";
  else if(language.toLowerCase().includes("fr")) return "fr";
  else if(language.toLowerCase().includes("de")) return "de";
  else if(language.toLowerCase().includes("it")) return "it";
  else if(language.toLowerCase().includes("nb")) return "nb";
  else if(language.toLowerCase().includes("pl")) return "pl";
  else if(language.toLowerCase().includes("pt")) return "pt";
  else if(language.toLowerCase().includes("es")) return "es";
  else if(language.toLowerCase().includes("sv")) return "sv";
  else if(language.toLowerCase().includes("cy")) return "cy";
  else return "en-gb";
}

export default function useOfficeLanguage() {
  const { updateLanguage } = useAppConfigStore();
  
  useEffect(() => {
    function getOutlookLanguage(): string {
      try {
        if (typeof Office !== "undefined" && Office?.context?.displayLanguage) {
          const language: string = Office.context.displayLanguage;
          return language;
        }
      } catch {}
      return "en";
    }

    // function getDateTimeFormatFromLocale(locale: string): { dateFormat: string; timeFormat: string } {
     
    // }


    function applyLanguageAndFormat() {
      const language = getOutlookLanguage();
      //const { dateFormat, timeFormat } = getDateTimeFormatFromLocale(language);
      
      // Update store
      updateLanguage(convertLanguageOAToLocal(language));
     // updateDateTimeFormat(dateFormat, timeFormat);
    }

    if (typeof Office !== "undefined") {
      Office.onReady?.(() => {
        applyLanguageAndFormat();
      });
    } else {
      // Fallback nếu không có Office context
      applyLanguageAndFormat();
    }
  }, [updateLanguage]);
}
